import { Box, useTheme } from "@mui/material";
import PartDetailCard from "./PartDetailCard";
import BreakdownMenuItem from "./BreakdownMenuItem";
import { History } from "@mui/icons-material";

interface BreakdownSidebarProps {
  oemPrice: number;
  sparePrice: number;
  childPartCount: number;
  isFlagPart: boolean;
  isAdminFlagged: boolean;
  activeMenu: string;
  onMenuChange: (menu: string) => void;
  version: "v1" | "v2";
  isEditing: boolean;
  isAdding: boolean;
  isEditingPartProcess: boolean;
  onFlaggedChange: () => void;
  canEdit: boolean;
}

const BreakdownSidebar = ({
  oemPrice,
  sparePrice,
  childPartCount,
  isFlagPart,
  isAdminFlagged,
  activeMenu,
  onMenuChange,
  version,
  isEditing,
  isAdding,
  isEditingPartProcess,
  onFlaggedChange,
  canEdit,
}: BreakdownSidebarProps) => {
  const theme = useTheme();

  return (
    <Box width="20%" display="flex" flexDirection="column" gap={1}>
      <PartDetailCard
        title="OEM Price"
        text={oemPrice.toString()}
        color={theme.palette.primary.main}
      />
      <PartDetailCard
        title="Spare Price"
        text={sparePrice.toString()}
        color={theme.palette.primary.main}
      />
      <PartDetailCard
        title="Child Part"
        text={childPartCount.toString()}
        color={theme.palette.grey[500]}
      />
      <PartDetailCard
        title="Flagged Part"
        text={"flagged"}
        color={theme.palette.grey[500]}
        isFlagged={isFlagPart}
        isAdminFlagged={isAdminFlagged}
        onFlaggedChange={onFlaggedChange}
        canEdit={canEdit}
      />
      <Box
        height="100%"
        display="flex"
        alignItems="center"
        flexDirection="column"
        justifyContent="space-between"
        sx={{
          backgroundColor: theme.palette.grey[200],
          borderRadius: 2,
          p: 1,
        }}
      >
        <Box
          mt={2}
          display="flex"
          width="100%"
          alignItems="center"
          flexDirection="column"
        >
          <BreakdownMenuItem
            label="CHILD PART INFORMATION"
            value="child-part"
            isActive={activeMenu === "child-part"}
            onClick={onMenuChange}
            disabled={isEditingPartProcess}
          />
          <BreakdownMenuItem
            label="MATERIAL COST"
            value="material-cost"
            isActive={activeMenu === "material-cost"}
            onClick={onMenuChange}
            disabled={isEditingPartProcess}
          />
          {version === "v1" ? (
            <BreakdownMenuItem
              label="PROCESS"
              value="process"
              isActive={activeMenu === "process"}
              onClick={onMenuChange}
            />
          ) : (
            <>
              <BreakdownMenuItem
                label="CHILD PART PROCESS"
                value="child-part-process"
                isActive={activeMenu === "child-part-process"}
                onClick={onMenuChange}
                disabled={isEditingPartProcess}
              />
              <BreakdownMenuItem
                label="PART PROCESS"
                value="part-process"
                isActive={activeMenu === "part-process"}
                onClick={onMenuChange}
                disabled={isEditing || isEditingPartProcess || isAdding}
              />
              <BreakdownMenuItem
                label="PART OTHER PROCESS"
                value="part-other-process"
                isActive={activeMenu === "part-other-process"}
                onClick={onMenuChange}
                disabled={isEditing || isEditingPartProcess || isAdding}
              />
            </>
          )}
        </Box>
        <Box
          mb={1}
          display="flex"
          width="100%"
          alignItems="center"
          justifyContent="center"
        >
          <BreakdownMenuItem
            label="HISTORY PRICE"
            value="history"
            icon={<History />}
            isActive={activeMenu === "history"}
            onClick={onMenuChange}
            isSecondary
            disabled={isEditing || isEditingPartProcess || isAdding}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default BreakdownSidebar;
